import React, {Component} from 'react';
import { withRouter } from "react-router-dom";





class HowItWorks extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>How It Works </h2>

                <br/>
               

                <h6> The process: Simple Overview</h6>
                <hr/>
                <br/> <br/>

                <div className='row'>
                    <div className='col-4'>
                         <h4>Step 1: Find the Item </h4>  
                        <br/> <br/>
                        <div className="text-center">
                            <img className='text-center' style={{width:"100px", height:"150px"}} src='./images/iphone_main.jpg'  alt=''/> 
                        </div>   
                        <br/>
                        <p className='text-primary'>The hotel's staff locates the item in a room, lobby or conference center. 
                        Using the BOUNTE mobile app, take a photo and add a description.  Save to the cloud.
                        </p>

                    </div>
                    <div className='col-4'>
                    <h4>Step 2: Locate for Guest </h4> 
                    <br/> <br/>
                    <div className="text-center">
                            <img className='text-center' style={{width:"150px", height:"150px"}} src='./images/howitworks_venue.png'  alt=''/> 
                        </div> 

                       <br/>
                        <p className='text-primary'> Log into BOUNTE Venue, click lost &amp; found from the menu at the top, enter search keywords and locate the lost items within the list. 
                        Click the item that best matchs what the guest is describing to view the details. 
                        </p>
                    </div>
                    <div className='col-4'>
                    <h4>Step 3: Ship It Back or Pickup </h4> 
                    <br/> <br/>
                        <div className="text-center">
                            <img className='text-center' style={{width:"150px", height:"150px"}} src='./images/cardboard-shipping-box-.png'  alt=''/> 
                        </div> 
                        <br/>
                         <p className='text-primary'> 

If the guest wants to have your item shipped back simply click the create shipping label from the lost and found items detail page. This will take you through a step-by-step wizard to initiate the return 
process for the guest. The return wizard will not only create a shipping workflow but also create a new claim behind the scenes. No need to create a claim first!
For Pickup-up: click new claim in the lost and found item editor and fill out the first name the last name email address.  Select Will Pick Up as the claim status. 

                        </p>

                    </div>
                </div>

               
                

                <br/>

               




                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(HowItWorks);
